<template>
	<div 
		class="task-block bg-white" 
		@click="openTaskSidebar(task)"
	>
		<div class="info-task-one">
			<div :class="`task-tags ${handlerStyleTags(task)}`">
				<span v-html="handlerTypeTaskTag(task)"></span>
			</div>
			<div class="task-tags-act ml-2">
				<span :class="`text-secondary`" v-html="handlerTypeReferenceId(task.reference_type_id)"></span>
			</div>
		</div>
		<div class="info-task-two line-height-17 mt-2">
			<div>
				<span class="font-size-16 text-brown">{{ task.title }}</span>
			</div>
		</div>

		<!-- <div class="info-task-two font-size-12 mt-2" v-if="!task.company_id && !task.order_id && !task.order && !task.finance_id">
			<div>
				<span class="text-brown">Без привязки к объектам</span>
			</div>
		</div> -->
		<div class="info-task-two font-size-12 mt-2" v-if="task.company_id">
			<div>
				<span class="text-brown">Клиент: {{ task.company.name }}</span>
			</div>
		</div>
		<div class="info-task-two font-size-12 mt-2" v-if="task.order_id">
			<div>
				<span class="text-brown">Заказ: #{{ task.order_id }}
					<span class="text-success text-uppercase font-weight-bold" v-if="task.order.reference_status_id == 421">(Закрыт)</span>
					<span class="text-danger text-uppercase font-weight-bold" v-if="task.order.reference_status_id == 362">(Отказ)</span>
				</span>
			</div>
		</div>
		<div class="info-task-two font-size-12" v-if="task.order">
			<div>
				<span class="text-brown">Клиент: {{ task.order.company ? task.order.company.name : task.order.temp_name }}</span>
			</div>
		</div>
		<div class="info-task-two font-size-12 mt-2" v-if="task.finance_id">
			<div>
				<span class="text-brown">Счет: {{ task.finance.invoice_number ? '#' + task.finance.invoice_number : 'номер не задан' }}</span>
			</div>
		</div>

		<div class="info-task-three mt-2">
			<!-- <div>
				<span class="ml-2 text-secondary">{{task.realization_at}}</span>
			</div> -->
			<div v-for="realizator in listProcessing" :key="realizator.id">
				<template v-if="realizator.avatar_path">
					<img :src="realizator.avatar_path" :id="`tooltip-${task.id}`" class="ml-1" style="width:25px;border-radius:25px">
				</template>
				<template v-else>
					<b-avatar :id="`tooltip-${task.id}`" :size="25" :text="nameAvatar(realizator.name)" class="ml-1"></b-avatar>
				</template>

				<!-- <b-tooltip :target="`tooltip-${task.id}`" triggers="hover" placement="bottom">
					Исполнитель: {{task.realizator.name}}
				</b-tooltip> -->
			</div>
			<div v-if="task.realizators.length > 3">
				<b-avatar :size="25" variant="info" class="ml-1 text-white font-size-12">+{{task.realizators.length - 3}}</b-avatar>
			</div>
			<div class="text-right flex-grow-1">
				<span class="task-id">#{{task.id}}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { openTaskSidebar } from '@/mixins/openTaskSidebar';
import { mixinTasks } from '@/mixins';

export default {
	props: {
		task: { type: Object, default: () => ({}) }
	},
	mixins: [
		mixinTasks,
		openTaskSidebar
	],
};
</script>
